import { render, staticRenderFns } from "./JettonTabHistoryRowMobile.vue?vue&type=template&id=56aebcf3"
import script from "./JettonTabHistoryRowMobile.vue?vue&type=script&lang=js"
export * from "./JettonTabHistoryRowMobile.vue?vue&type=script&lang=js"
import style0 from "./JettonTabHistoryRowMobile.vue?vue&type=style&index=0&id=56aebcf3&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports